import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { EnactReserveBarComponent } from './enact-reserve-bar.component';
import { FormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';


@NgModule({
  declarations: [
    EnactReserveBarComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    TranslateModule
  ],
  exports: [
    EnactReserveBarComponent
  ]
})
export class EnactReserveBarModule { }